import { visibilityStates } from "../../../app/config";
import {format} from "../../../utils/timeZoneUtils";

export const identificationTypes = [
    {
        value: 0,
        text: 'clientNumber',
    },
    {
        value: 1,
        text: 'billNumber',
    },
    {
        value: 2,
        text: 'orderNumber',
    },
    {
        value: 3,
        text: 'others',
    },
]

export const dataFieldsArray = [
    {
        name: 'id',
    },
    {
        name: 'firstCreatedAt',
        convert: (value) => format(value)
    },
    {
        name: 'date',
        convert: (value) => format(value)
    },
    {
        name: 'identyficationType',
        items: identificationTypes,
    },
    {
        name: 'identyfication',
    },
    {
        name: 'typeId',
        modelName: 'TypeId',
        required: true,
    },
    {
        name: 'isPublic',
        modelName: 'IsPublic',
        items: visibilityStates,
        required: true,
    },
    {
        name: 'title',
        modelName: 'Title',
        required: true,
    },
    {
        name: 'description',
        modelName: 'Description',
        textarea: true,
        rows: 5,
    }
];